import React, { useState, useEffect } from 'react';
import AgentEventCalendarPanel from '../Panels/AgentEventCalendarPanel';
import { WebAPI } from '../../MedicareProAPI/API/WebAPI';

export default function AgentEventCalendarPage(props) {
  const webAPI = new WebAPI();
  webAPI.setAccessToken(props.userAccessToken);

  return (
    <>
      <div class="row mb-3">
        <div class="col-12">
          <section className="ds">
            <AgentEventCalendarPanel
              userId={props.userId}
              userAccessToken={props.userAccessToken}
            />
          </section>
        </div>
      </div>
    </>
  );
}
